import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/user-assignment/UserAssignmentAction";
import { getAuthorities, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import { StudentUsersFilter } from "./student-users-filter/StudentUsersFilter";
import { StudentUsersTable } from "./student-users-table/StudentUsersTable";
import { useStudentUsersUIContext } from "./StudentUsersUIContext";

export function StudentUsersCard({
  history,
  userGroupId,
  userType
}) {
  // Student Users Card UI Context
  const studentUsersUIContext = useStudentUsersUIContext();
  const studentUsersUIProps = useMemo(() => {
    return {
      ids: studentUsersUIContext.ids
    };
  }, [studentUsersUIContext]);

  // Getting curret state of UserAssignment from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.userAssignment }),
    shallowEqual
  );  
  const { authorities } = currentState;

  // Authority Parameters
  const { isEditionAuthorized } = getAuthorities(authorities);

  // Student Users Redux state
  const dispatch = useDispatch();

  /** Belli Bir Kullanıcı Grubuna Ait Kullanıcı Listesini Kaydeder */
  const saveUsers = (ids) => {
    dispatch(actions.saveUsers(userType, userGroupId, ids)).then(result => onResult(result));
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/kullanici-ve-kullanici-gruplari/${userType}`), 2500);
  };

  const title = <>Öğrenci Kullanıcı Listesi{studentUsersUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{studentUsersUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      <CardHeader title={title}>
        {
          isEditionAuthorized &&
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => saveUsers(studentUsersUIProps.ids)}
            >
              Kaydet
            </button>
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <StudentUsersFilter />
        <StudentUsersTable />
      </CardBody>
    </Card>
  );
}